import { InsuranceCheckState } from "@medbillai/generated-graphql-types";

/** Reads a value this client doesn't know as the enum's `UNRECOGNIZED`. */
export const known = <M extends string>(
  members: Readonly<Record<string, M>> & { readonly UNRECOGNIZED: M },
  value: string,
): M => Object.values(members).find(m => m === value) ?? members.UNRECOGNIZED;

/** Why the eligibility check has no answer to read. */
export type InsuranceCheckMiss =
  | "payerUninsured"
  | "notStarted"
  | "needsInfo"
  | "checkFailed"
  | "unknownState";

export const checkOutcome = (
  state: InsuranceCheckState,
): "pending" | "checked" | InsuranceCheckMiss => {
  switch (state) {
    case InsuranceCheckState.CHECKING:
      return "pending";
    case InsuranceCheckState.CHECKED:
      return "checked";
    case InsuranceCheckState.UNINSURED:
      return "payerUninsured";
    case InsuranceCheckState.NOT_STARTED:
      return "notStarted";
    case InsuranceCheckState.NEEDS_INFO:
      return "needsInfo";
    case InsuranceCheckState.FAILING:
    case InsuranceCheckState.STOPPED:
      return "checkFailed";
    case InsuranceCheckState.UNRECOGNIZED:
      return "unknownState";
  }
};
